import { Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';
import { nonAuthGuard } from './guards/non-auth.guard';

export const routes: Routes = [
  {
    path: 'apps/atrasos',
    loadComponent: () =>
      import('./pages/gate/gate-portal.page').then(c => c.GatePortalPage),
    canActivate: [authGuard],
    children: [
      {
        path: 'control',
        loadComponent: () =>
          import('./pages/gate/control/gate-control.page').then(
            c => c.GateControlPage,
          ),
      },
      {
        path: 'registros',
        loadComponent: () =>
          import('./pages/gate/records/gate-records.page').then(
            c => c.GateRecordsPage,
          ),
      },
      {
        path: 'panel',
        loadComponent: () =>
          import('./pages/gate/dashboard/gate-dashboard.page').then(
            c => c.GateDashboardPage,
          ),
      },
      {
        path: 'reportes',
        loadComponent: () =>
          import('./pages/gate/reports/gate-reports.page').then(
            c => c.GateReportsPage,
          ),
      },
      {
        path: 'auditoria',
        loadComponent: () =>
          import('./pages/gate/audit/gate-audit.page').then(
            c => c.GateAuditPage,
          ),
      },
      {
        path: 'ajustes',
        loadComponent: () =>
          import('./pages/gate/settings/gate-settings.page').then(
            c => c.GateSettingsPage,
          ),
      },
    ],
  },
  {
    path: '',
    loadComponent: () =>
      import('./layout/app-shell.component').then(c => c.AppShellComponent),
    children: [
      {
        path: '',
        pathMatch: 'full',
        loadComponent: () =>
          import('./pages/home/home.page').then(c => c.HomePage),
      },
      {
        path: 'login',
        pathMatch: 'full',
        loadComponent: () =>
          import('./pages/login/login.page').then(c => c.LoginPage),
        canActivate: [nonAuthGuard],
      },
      {
        path: 'apps',
        pathMatch: 'full',
        loadComponent: () =>
          import('./pages/apps/apps.page').then(c => c.AppsPage),
        canActivate: [authGuard],
      },
    ],
  },
  { path: '**', redirectTo: '', pathMatch: 'full' },
];
